export default "__VITE_ASSET__9O3XgAHy__"